import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=7e87ea9a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=7e87ea9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e87ea9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e87ea9a')) {
      api.createRecord('7e87ea9a', component.options)
    } else {
      api.reload('7e87ea9a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=7e87ea9a&scoped=true&", function () {
      api.rerender('7e87ea9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z8EEGzKbR1Np/JS/comp/PopupDialog.vue"
export default component.exports